export default "__VITE_ASSET__bu636ttO__"